import React, { useState, useEffect } from "react";
import { Modal, Input, Switch, Select, Tooltip } from "antd";
import floppyDiskImg from "../../../../assets/img/floppy-disk.svg";
import { CompletionsButtons } from "../buttons/completion-button";
import arrowdown from "../../../../assets/img/arrow-down.svg";
import puzzle from "../../../../assets/img/thumbs-down.svg";
import { Link, useNavigate } from "react-router-dom";
import {
  TackleRadioButtons,
  SackRadioButtons,
  FlagSwitchButtons,
} from "../CustomSwitchButtons.js";

function ThrowModal({
  state,
  dispatch,
  close,
  update,
  item,
  getStats,
  school_id,
  schoolCustomStats,
  loadAllPlayerList,
  play,
  handleUpdatePlay,
  updateInputGrade,
  updateGrade,
  handleExpandToggle,
}) {
  const [modalWidth, setModalWidth] = useState(425);
  let history = useNavigate();
  const [customStats, setCustomStats] = useState([]);
  const [customStatValues, setCustomStatValues] = useState(
    JSON.parse(item.custom_stats || "{}")
  );
  const [storage, setStorage] = useState({});

  const handleSaveCustomStat = (stat, value) => {
    const _customStatValues = { ...customStatValues };
    _customStatValues[stat.label] = value;
    setCustomStatValues(_customStatValues);
    updateGrade("custom_stats", JSON.stringify(_customStatValues));
  };

  const handleCStats = () => {
    setCustomStatValues(JSON.parse(item.custom_stats || "{}"));
    const _customStats = schoolCustomStats?.filter((stat) => stat.odk == "o");
    setCustomStats(
      _customStats?.length
        ? _customStats?.filter((stat) => stat.index == "1")
        : []
    );
  };
  useEffect(handleCStats, [item.custom_stats, schoolCustomStats, state]);
  useEffect(handleCStats, []);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setModalWidth(352);
    } else {
      setModalWidth(425);
    }
  }, [window.innerWidth]);

  return (
    state.throw && (
      <div className="w-full text-[12px] flex justify-between text-[#0F1A24]">
      <div
        style={{ border: "1px solid #F3F5F7" }}
        className="w-[49%]"
      >
        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[50%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Completion</span>
          </div>{" "}
          <div className="px-2 py-2 w-[50%] turn-over actor flex items-center justify-center">
            <CompletionsButtons
              item={item}
              defaultState={item?.receptions}
              handleQuickUpdate={(a, b, c, d, e, f) => {
                update(a, b, c, d, e, f);
              }}
              title="receptions"
              imageTwo={puzzle}
              value="1"
              tooltipTitle="Incomplete"
              tooltipTitleTwo="Dropped"
              tooltipTitleThree="Bad Ball"
              tooltipTitleFour={"Complete"}
              color="yellow"
              text={item?.receptions}
              imageFour={arrowdown}
            />
          </div>
        </div>

        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[50%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>GN/LS</span>
          </div>{" "}
          <div className="px-2 py-2 w-[50%] turn-over actor flex items-center justify-center">
            <Input
              onChange={({ target: { value } }) =>
                handleUpdatePlay(play?.id, { gn: value })
              }
              defaultValue={play?.gn}
              size="large"
            />
          </div>
        </div>

        <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[50%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Sacks</span>
            </div>{" "}
            <div className="px-2 py-2 w-[50%] turn-over actor flex items-center justify-center">
            <Switch
              defaultChecked={item?.sacks}
              onChange={(e) => updateGrade("sacks", e ? 1 : 0)}
            />
            </div>
          </div>
        {/* <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[50%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Yards After Catch</span>
          </div>{" "}
          <div className="px-2 py-2 w-[50%] turn-over actor flex items-center justify-center">
          <Input defaultValue={item.yards_after_catch} onChange={(e)=>updateInputGrade('yards_after_catch_throw',e )} size="small" className="w-[40%] p-1" />{" "}
       
          </div>
        </div> */}
        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[50%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>TD</span>
          </div>{" "}
          <div className="px-2 py-2 w-[50%] turn-over actor flex items-center justify-center">
            <Switch
              defaultChecked={item?.qb_td}
              onChange={(e) => updateGrade("qb_td", e ? 1 : 0)}
            />{" "}
          </div>
        </div>
        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[50%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>2 Pt. Conversion</span>
          </div>{" "}
          <div className="px-2 py-2 w-[50%] turn-over actor flex items-center justify-center">
            <Switch
              defaultChecked={item?.two_part_conversion}
              onChange={(e) => updateGrade("two_part_conversion", e ? 1 : 0)}
            />{" "}
          </div>
        </div>
        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[50%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Interception</span>
          </div>{" "}
          <div className="px-2 py-2 w-[50%] fumble flex items-center justify-center">
            <Switch
              defaultChecked={item?.interception}
              onChange={(e) => updateGrade("interception", e ? 1 : 0)}
            />{" "}
          </div>
        </div>
      </div>
        <div className="w-[49%] px-2">
          <div className="flex items-center text-md mb-2">
            <button
              onClick={() => handleExpandToggle(item, "throw-modal")}
              className="flex items-center focus:outline-0 justify-center w-fit bg-[#1A91FF] text-[#ffffff] px-3 py-2 rounded-[4px]"
            >
              <img src={floppyDiskImg} className="w-6" />
              <span className="ml-2">Save and close</span>
            </button>
          </div>
          <span className="font-inter text-[14px] font-bold">
            Custom Stats{" "}
          </span>
          <div
            style={{ border: "1px solid #F3F5F7" }}
            className="mt-1 text-[12px] text-[#0F1A24] mb-2"
          >
            {customStats?.map((stat) => (
              <div
                key={stat?.label}
                className="flex items-center"
                style={{ borderBottom: "1px solid #F3F5F7" }}
              >
                <div
                  className="w-[70%] px-2 py-2 font-bold"
                  style={{ borderRight: "1px solid #F3F5F7" }}
                >
                  <span>{stat?.label}</span>
                </div>{" "}
                <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
                  {stat?.input_type == "numeric" ? (
                    <Input
                      defaultValue={
                        JSON.parse(item.custom_stats || "{}")[stat.label]
                      }
                      onChange={(e) =>
                        handleSaveCustomStat(stat, e.target.value)
                      }
                      size="small"
                      className="w-[40%] p-1"
                    />
                  ) : (
                    <Switch
                      defaultChecked={
                        JSON.parse(item.custom_stats || "{}")[stat.label]
                      }
                      onChange={(e) => handleSaveCustomStat(stat, e ? 1 : 0)}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
          <span className="text-[#8698A9] mt-2">
            Edit custom stats in your{" "}
            <span onClick={() => history("/add-stats")} className="underline cursor-pointer">
              Admin Settings
            </span>
          </span>
        </div>
      </div>
    )
  );
}

export default ThrowModal;
